"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("../../stylesheets/views/intranet/IntranetHeader.css");

var _mobxReact = require("mobx-react");

var _classnames = _interopRequireDefault(require("classnames"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _constants = require("../../util/constants");

var _Tooltip = _interopRequireDefault(require("../../gradifui/components/tooltip/Tooltip"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getChildrenWithSelectedProp = function getChildrenWithSelectedProp(props) {
  return _react.default.Children.map(props.children, function (child) {
    return child && /*#__PURE__*/_react.default.cloneElement(child, {
      selected: child.props.name && child.props.name === props.selected
    });
  });
};

var Navigation = function Navigation(props) {
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: props.className
  }, getChildrenWithSelectedProp(props));
};

var Item = function Item(_ref) {
  var selected = _ref.selected,
      className = _ref.className,
      href = _ref.href,
      icon = _ref.icon,
      text = _ref.text;
  var itemClassNames = {
    "header-item": true,
    selected: selected
  };
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    component: /*#__PURE__*/_react.default.createElement("a", {
      className: (0, _classnames.default)(className, itemClassNames),
      href: href
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: icon
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "nav-label"
    }, text)),
    onHover: true
  }, text);
};

var IntranetNavBar = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(IntranetNavBar, _React$Component);

  var _super = _createSuper(IntranetNavBar);

  function IntranetNavBar() {
    _classCallCheck(this, IntranetNavBar);

    return _super.apply(this, arguments);
  }

  _createClass(IntranetNavBar, [{
    key: "render",
    value: function render() {
      var _this$props$session;

      var user = ((_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : _this$props$session.user) || {};
      return /*#__PURE__*/_react.default.createElement(Navigation, {
        className: "left-nav",
        selected: this.props.selected
      }, /*#__PURE__*/_react.default.createElement(Item, {
        name: "current-user",
        icon: "icon-users",
        text: "".concat(user.firstName, " ").concat(user.lastName)
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "dashboard",
        href: _constants.URLS.HOME,
        icon: "icon-gauge",
        text: "Dashboard"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "entities",
        href: _constants.URLS.INTRANET.ENTITIES,
        icon: "icon-globe",
        text: "Entities"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "users",
        href: _constants.URLS.INTRANET.USERS,
        icon: "icon-users",
        text: "Users"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "reporting",
        href: _constants.URLS.INTRANET.REPORTING,
        icon: "icon-chart-line",
        text: "Reporting"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "servicers",
        href: _constants.URLS.INTRANET.SERVICER_ADDRESSES,
        icon: "icon-bank",
        text: "Servicers"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "lenders",
        href: _constants.URLS.INTRANET.LENDERS,
        icon: "icon-commercial-building",
        text: "Lenders"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "transactions",
        href: _constants.URLS.INTRANET.TRANSACTIONS,
        icon: "icon-dollar",
        text: "Transactions"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "review",
        href: _constants.URLS.INTRANET.REVIEW,
        icon: "icon-search",
        text: "Review"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "jobs",
        href: _constants.URLS.INTRANET.JOBS,
        icon: "icon-cog-alt",
        text: "Jobs"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "calendar",
        href: _constants.URLS.INTRANET.CALENDAR,
        icon: "icon-calendar",
        text: "Calendar"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "referrals",
        href: _constants.URLS.INTRANET.REFERRALS,
        icon: "icon-loop-alt-outline",
        text: "Referrals"
      }), /*#__PURE__*/_react.default.createElement(Item, {
        name: "settings",
        href: _constants.URLS.INTRANET.SETTINGS,
        icon: "icon-cog",
        text: "Settings"
      }));
    }
  }]);

  return IntranetNavBar;
}(_react.default.Component)) || _class;

var _default = (0, _Propulator.default)(IntranetNavBar, {
  SessionStore: ["session"]
});

exports.default = _default;